import axios from '|/helpers/axios';
import { SLATE_PURCHASE_STATUS_ENDPOINTS } from './endpoints';
import { SlatePurchaseStatus } from './types';

export const getSlatePurchaseStatus = (abortSignal: AbortSignal) =>
  axios
    .get<SlatePurchaseStatus>(SLATE_PURCHASE_STATUS_ENDPOINTS.STATUS, { signal: abortSignal })
    .then(res => res.data);
